/* ============================================================
   KROQ — Cross-selling AJAX dans le panier
   - Intercepte les clics sur [data-kroq-add]
   - Ajoute la variante via /cart/add.js (avec re-render de la
     section drawer pour rester aligné sur le morph Horizon)
   - Émet l'événement 'cart:update' du thème pour rafraîchir le
     panier + déclencher l'auto-open du drawer.
   Défensif : no-op silencieux si le panier/thème diffère.
   ============================================================ */
(function () {
  'use strict';

  const ADD_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/') + 'cart/add.js';

  /** Récupère l'id de section du drawer pour demander son re-render. */
  function getDrawerSectionId() {
    const el = document.querySelector('cart-items-component[data-drawer]');
    return el ? el.getAttribute('data-section-id') : null;
  }

  async function addToCart(variantId, button) {
    const sectionId = getDrawerSectionId();
    const body = {
      items: [{ id: Number(variantId), quantity: 1 }],
    };
    if (sectionId) {
      body.sections = [sectionId];
      body.sections_url = window.location.pathname;
    }

    const res = await fetch(ADD_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) throw new Error('cart/add failed: ' + res.status);
    const data = await res.json();

    // Récupère l'état complet du panier (pour le détail de l'événement).
    let cart = null;
    try {
      const cartRes = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        headers: { Accept: 'application/json' },
      });
      if (cartRes.ok) cart = await cartRes.json();
    } catch (e) {
      /* non bloquant */
    }

    // Émet l'événement attendu par Horizon (mirroir de CartAddEvent / CartUpdateEvent).
    const detail = {
      resource: cart,
      sourceId: 'kroq-cross-sell',
      data: {
        source: 'kroq-cross-sell',
        itemCount: cart ? cart.item_count : data.item_count,
        variantId: String(variantId),
        sections: data.sections || null,
      },
    };
    (button || document).dispatchEvent(
      new CustomEvent('cart:update', { bubbles: true, detail })
    );

    return data;
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-kroq-add]');
    if (!button || button.disabled) return;

    event.preventDefault();
    const variantId = button.getAttribute('data-kroq-add');
    if (!variantId) return;

    button.setAttribute('data-loading', '');
    button.disabled = true;

    addToCart(variantId, button)
      .catch(function (err) {
        console.error('[Kroq] cross-sell add error:', err);
      })
      .finally(function () {
        button.removeAttribute('data-loading');
        button.disabled = false;
      });
  });
})();
